import { ParamDict } from "./params.tsx";

export type ParamDictProps<T extends ParamDict> = {
  [K in keyof T]: T[K]["value"];
};

export type ParamDictKeys<T extends ParamDict> = {
  [K in keyof T]: T[K]["value"];
};

export type ParamDictPayload<T extends ParamDict> = {
  name: keyof T;
  value: T[keyof T]["value"];
};

export type ParamDictKeyOnChange<T extends ParamDict> = (
  name: keyof T,
  value: T[keyof T]["value"],
) => void;

export function ParamDictToProps<T extends ParamDict>(dict: T) {
  const props = Object.fromEntries(
    Object.entries(dict).map(([k, p]) => {
      return [k, p.value];
    }),
  );
  return props as ParamDictProps<T>;
}
